import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'primereact/button';
import { PagesPaths } from '@/enums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import {
  faPlus,
  faReply,
  faShare,
  faWarehouse,
  faSquarePlus,
} from '@fortawesome/free-solid-svg-icons';

import './ToolBar.scss';

const ToolBar: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('mySettlement');

  return (
    <div className="button-group">
      <Button
        label={t('create')}
        className="with-separator p-button-link active"
        icon={<FontAwesomeIcon icon={faPlus} />}
      />
      <Button
        label={t('fclImport')}
        className="with-separator p-button-link"
        icon={<FontAwesomeIcon icon={faReply} />}
        onClick={() => navigate(PagesPaths.ImportFCL)}
      />
      <Button
        label={t('fclExport')}
        className="with-separator p-button-link"
        icon={<FontAwesomeIcon icon={faShare} />}
        onClick={() => navigate(PagesPaths.ExportFCL)}
      />
      <Button
        label={t('depot20')}
        className="with-separator p-button-link"
        icon={<FontAwesomeIcon icon={faWarehouse} />}
        onClick={() => navigate(PagesPaths.Depo20)}
      />
      <Button
        label={t('additionalService')}
        className="with-separator p-button-link"
        icon={<FontAwesomeIcon icon={faSquarePlus} />}
        onClick={() => navigate(PagesPaths.ServicioAdicional)}
      />
      <Button
        label={t('vacioImportacion')}
        className="with-separator p-button-link"
        icon={<FontAwesomeIcon icon={faReply} />}
        onClick={() => navigate(PagesPaths.VacioImportacion)}
      />
    </div>
  );
};

export default ToolBar;
